import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { storeWithExpiration } from '../../utils/common';
import {
  createCredentials,
  removeCredentials,
  retrieveCredentials,
  updateCredentials,
} from '../../actions/superadmin';
import SFTPForm from './SFTPForm';

const FORM_ID = 'sftpForm';

export class SFTPFormContainer extends React.Component {
  static propTypes = {
    accountId: PropTypes.number.isRequired,
    admin: PropTypes.bool.isRequired,
    sftpInfo: PropTypes.object.isRequired,
    cancelFunction: PropTypes.func.isRequired,
    createCredentialsAction: PropTypes.func.isRequired,
    retrieveCredentialsAction: PropTypes.func.isRequired,
    removeCredentialsAction: PropTypes.func.isRequired,
    updateCredentialsAction: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
  };

  componentWillMount = () => {
    const { accountId, retrieveCredentialsAction } = this.props;

    // fetches the credentials associated with the appropriate account, if they exist
    const token = storeWithExpiration.get('token');
    retrieveCredentialsAction(accountId, token);
  };

  createSFTPCredentialsAction = params => {
    const { createCredentialsAction, accountId, cancelFunction } = this.props;
    const token = storeWithExpiration.get('token');
    const credentialsInfo = {
      username: params.username,
      passwordHash: params.passwordHash,
    };
    cancelFunction('sftpDialog');
    createCredentialsAction(accountId, credentialsInfo, token);
  };

  removeSFTPCredentialsAction = () => {
    const { accountId, cancelFunction, removeCredentialsAction } = this.props;
    const token = storeWithExpiration.get('token');

    cancelFunction('sftpDialog');
    removeCredentialsAction(accountId, token);
  };

  updateSFTPCredentialsAction = params => {
    const { accountId, cancelFunction, updateCredentialsAction } = this.props;
    const token = storeWithExpiration.get('token');
    const updateInfo = {
      username: params.username,
      passwordHash: params.passwordHash,
    };
    cancelFunction('sftpDialog');
    updateCredentialsAction(accountId, updateInfo, token);
  };

  render() {
    const { admin, invalid, sftpInfo, cancelFunction, handleSubmit, submitting } = this.props;

    return (
      <SFTPForm
        admin={admin}
        createForm={sftpInfo.username === '' && admin}
        invalid={invalid}
        sftpInfo={sftpInfo}
        submitting={submitting}
        closeFunction={cancelFunction}
        deleteButtonFunction={this.removeSFTPCredentialsAction}
        handleSubmit={handleSubmit}
        submitFunction={
          sftpInfo.username === '' && admin
            ? this.createSFTPCredentialsAction
            : this.updateSFTPCredentialsAction
        }
      />
    );
  }
}

const validate = values => {
  const errors = {};

  if (!values.username || values.username === '') {
    errors.username = 'Required';
  }
  if (!values.passwordHash || values.passwordHash === '') {
    errors.passwordHash = 'Required';
  } else if (values.passwordHash !== values.confirmPassword) {
    errors.passwordHash = 'Passwords must match';
  } else if (values.passwordHash.length < 8) {
    errors.passwordHash = 'Must be at least 8 characters';
  } else if (!values.passwordHash.match(/^(?=.*[a-z])(?=.*[A-Z]).+$/)) {
    errors.passwordHash = 'Must contain at least one uppercase and lowercase letter';
  } else if (!values.passwordHash.match(/^(?=.*\d).+$/)) {
    errors.passwordHash = 'Must contain at least one number';
  }
  if (!values.confirmPassword || values.confirmPassword === '') {
    errors.confirmPassword = 'Required';
  }
  return errors;
};

function mapStateToProps(state) {
  const { superadmin } = state;
  const initialValues = {
    username: ' ',
  };
  const sftpInfo = superadmin.get('sftpInfo');
  return { sftpInfo, initialValues };
}

const SFTPFormContainerRF = reduxForm({
  form: FORM_ID,
  validate,
})(SFTPFormContainer);

export default connect(mapStateToProps, {
  createCredentialsAction: createCredentials,
  retrieveCredentialsAction: retrieveCredentials,
  removeCredentialsAction: removeCredentials,
  updateCredentialsAction: updateCredentials,
})(SFTPFormContainerRF);
